const translations = {
  "en": {
    "Auto-renew is off. You'll keep %{plan} until %{date}.": "Auto-renew is off. You'll keep %{plan} until %{date}.",
    "Ed Complete": "Ed Complete"
  },
  "zh-tw": {
    "Auto-renew is off. You'll keep %{plan} until %{date}.": "自動續訂已關閉。您將繼續使用 %{plan} 至 %{date}。",
    "Ed Complete": "Ed Complete"
  }
};

export default translations;
